const CONSENT_COOKIE_NAME = 'consent_status';

const getCookieOptions = () => {
  const expires = new Date();
  expires.setMonth(expires.getMonth() + 3);
  const domain = window.location.hostname === 'localhost' ? 'localhost' : `andersenlab.com`;

  return { expires, domain };
};

export { CONSENT_COOKIE_NAME, getCookieOptions };
